import {
	Home1,
	SubtopicFinalTeam1,
	SubtopicFive,
	SubtopicFiveActivityOne,
	SubtopicFiveFinalPoints,
	SubtopicFour,
	SubtopicFourActivityOne,
	SubtopicFourActivityTwo,
	SubtopicFourFinalPoints,
	SubtopicOne,
	SubtopicOneActivityFive,
	SubtopicOneActivityFour,
	SubtopicOneActivityOne,
	SubtopicOneActivityThree,
	SubtopicOneActivityTwo,
	SubtopicOneFinalPoint,
	SubtopicSeven,
	SubtopicSevenActivityOne,
	SubtopicSevenActivityTwo,
	SubtopicSevenFinalPoints,
	SubtopicSix,
	SubtopicSixActivityOne,
	SubtopicSixFinalPoints,
	SubtopicThree,
	SubtopicThreeActivityOne,
	SubtopicThreeActivityTwo,
	SubtopicThreeFinalPoints,
	SubtopicTwo,
	SubtopicTwoActivityOne,
	SubtopicTwoActivityThree,
	SubtopicTwoActivityTwo,
	SubtopicTwoFinalPoints
} from "../pages";
// import { HomeMenu3d } from "../pages/HomeMenu3d";
import { Introduction } from "../pages/Introduction";

export const pathTeam1 = {
	path: "home1",
	element: <Home1 />,
	children: [
		{
			index: true,
			// element: <HomeMenu3d></HomeMenu3d>,
			element: <></>,
		},
		{
			path: "introduction",
			element: <Introduction />,
		},
		{
			path: "tema1",
			children: [
				{
					path: "subtema1",
					children: [
						{
							index: true,
							path: "intro",
							element: <SubtopicOne></SubtopicOne>,
						},
						{
							path: "activityone",
							element: <SubtopicOneActivityOne></SubtopicOneActivityOne>,
						},
						{
							path: "activitytwo",
							element: <SubtopicOneActivityTwo></SubtopicOneActivityTwo>,
						},
						{
							path: "activitythree",
							element: <SubtopicOneActivityThree></SubtopicOneActivityThree>,
						},
						{
							path: "activityfour",
							element: <SubtopicOneActivityFour></SubtopicOneActivityFour>,
						},
						{
							path: "activityfive",
							element: <SubtopicOneActivityFive></SubtopicOneActivityFive>,
						},
						{
							path: "activityresult",
							element: <SubtopicOneFinalPoint />,
						},
					],
				},
				{
					path: "subtema2",
					children: [
						{
							index: true,
							path: "intro",
							element: <SubtopicTwo></SubtopicTwo>,
						},
						{
							path: "activityOne",
							element: <SubtopicTwoActivityOne></SubtopicTwoActivityOne>,
						},
						{
							path: "activityTwo",
							element: <SubtopicTwoActivityTwo></SubtopicTwoActivityTwo>,
						},
						{
							path: "activityThree",
							element: <SubtopicTwoActivityThree></SubtopicTwoActivityThree>,
						},
						{
							path: "activityresult",
							element: <SubtopicTwoFinalPoints></SubtopicTwoFinalPoints>,
						},
					],
				},
				{
					path: "subtema3",
					children: [
						{
							index: true,
							path: "intro",
							element: <SubtopicThree></SubtopicThree>,
						},
						{
							path: "activityOne",
							element: <SubtopicThreeActivityOne></SubtopicThreeActivityOne>,
						},
						{
							path: "activityTwo",
							element: <SubtopicThreeActivityTwo></SubtopicThreeActivityTwo>,
						},
						{
							path: "activityresult",
							element: <SubtopicThreeFinalPoints></SubtopicThreeFinalPoints>,
						},
					],
				},
				{
					path: "subtema4",
					children: [
						{
							index: true,
							path: "intro",
							element: <SubtopicFour></SubtopicFour>,
						},
						{
							path: "activityOne",
							element: <SubtopicFourActivityOne></SubtopicFourActivityOne>,
						},
						{
							path: "activityTwo",
							element: <SubtopicFourActivityTwo></SubtopicFourActivityTwo>,
						},
						{
							path: "activityresult",
							element: <SubtopicFourFinalPoints></SubtopicFourFinalPoints>,
						},
					],
				},
				{
					path: "subtema5",
					children: [
						{
							index: true,
							path: "intro",
							element: <SubtopicFive></SubtopicFive>,
						},
						{
							path: "activityOne",
							element: <SubtopicFiveActivityOne />,
						},
						{
							path: "activityresult",
							element: <SubtopicFiveFinalPoints></SubtopicFiveFinalPoints>,
						},
					],
				},
				{
					path: "subtema6",
					children: [
						{
							index: true,
							path: "intro",
							element: <SubtopicSix></SubtopicSix>,
						},
						{
							path: "activityOne",
							element: <SubtopicSixActivityOne />,
						},
						{
							path: "activityresult",
							element: <SubtopicSixFinalPoints></SubtopicSixFinalPoints>,
						},
					],
				},
				{
					path: "subtema7",
					children: [
						{
							index: true,
							path: "intro",
							element: <SubtopicSeven></SubtopicSeven>,
						},
						{
							path: "activityOne",
							element: <SubtopicSevenActivityOne />,
						},
						{
							path: "activityTwo",
							element: <SubtopicSevenActivityTwo />,
						},
						{
							path: "activityresult",
							element: <SubtopicSevenFinalPoints></SubtopicSevenFinalPoints>,
						},
					],
				},
				{
					path: "final",
					children: [
						{
							index: true,
							element: <SubtopicFinalTeam1></SubtopicFinalTeam1>,
						},
					],
				},
			],
		}

	]
}